import { StandardProps } from "@/components/componentMap";
import { Price } from "@/components/Price/Price";
import { RatingAndReviews } from "@/components/RatingAndReviews/RatingAndReviews";
import classNames from "classnames/bind";
import styles from "./PriceAndReviews.module.scss";

const cx = classNames.bind(styles);

export function PriceAndReviews({
  product,
  configProps,
  flags,
}: Pick<StandardProps, "product" | "configProps" | "flags">) {
  const wrapOnMobile = Boolean(configProps?.wrapOnMobile);

  return (
    <div
      className={cx(styles.container, {
        wrapOnMobile: wrapOnMobile,
      })}
      data-testid="PriceAndReviews"
      data-component="PriceAndReviews"
    >
      <Price product={product} configProps={configProps} flags={flags} />
      <RatingAndReviews
        product={product}
        configProps={configProps}
        flags={flags}
      />
    </div>
  );
}
